import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule, LoaderModule } from '@northfork/ng-basics'
import { CommandCardComponent } from './command-card/command-card.component'
import { CommandsDrawerComponent } from './commands-drawer/commands-drawer.component'

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    NgbDropdownModule,
    GenericComponentsModule,
    LoaderModule,
    NgbTooltipModule,
  ],
  declarations: [CommandsDrawerComponent, CommandCardComponent],
  exports: [CommandsDrawerComponent],
})
export class CommandsModule {}
